import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const requestGetReportLayouts = () =>
    axios.get(`${apiUrl}reportLayouts`);

export const requestGetReportLayoutById = (reportId) =>
    axios.get(`${apiUrl}reportLayouts/${reportId}`);

export const requestInsertReportLayout = (data) =>
    axios.post(`${apiUrl}reportLayouts`, data);

export const requestUpdateReportLayout = (reportId, data) =>
    axios.put(`${apiUrl}reportLayouts/${reportId}`, data);

export const requestDeleteReportLayout = (reportId) =>
    axios.delete(`${apiUrl}reportLayouts/${reportId}`);

export const requestGetJobs = () =>
    axios.get(`${apiUrl}jobs?includeInactive=false`);

export const requestGetJobProducts = (jobId) =>
    axios.get(`${apiUrl}jobs/jobProducts?jobId=${jobId}`);
